import { PaginatedListResult, usePaginatedList } from "@hooks/usePaginatedList";
import { ServicesURL } from "@utils/utilsApi";

export interface SiteListItem {
  id: number | string;
  name?: string;
  code?: string;
  street?: string | null;
  street_number?: string | null;
  municipality?: string | null;
  postal_code?: string | null;
  province?: string | null;
  country_description?: string | null;
  country_code?: string | null;
}

export interface RoomListItem {
  id: number | string;
  name?: string;
  code?: string;
  max_capacity?: number | null;
  type?: string | null;
  bookable?: boolean;
}

interface UseSitesListArgs {
  corporateId: string | number;
  page: number;
  pageSize: number;
  search?: string;
}

export const useSitesList = ({
  corporateId,
  page,
  pageSize,
  search,
}: UseSitesListArgs): PaginatedListResult<SiteListItem> => {
  const url = corporateId
    ? `${ServicesURL.sites.replace(
        "{corporateId}",
        String(corporateId),
      )}?bookable=true`
    : null;

  return usePaginatedList<SiteListItem>(url, {
    page,
    pageSize,
    search,
    searchField: "name",
  });
};

interface UseRoomsListArgs {
  corporateId: string | number;
  siteId?: string | number;
  page: number;
  pageSize: number;
  search?: string;
}

export const useRoomsList = ({
  corporateId,
  siteId,
  page,
  pageSize,
  search,
}: UseRoomsListArgs): PaginatedListResult<RoomListItem> => {
  const url =
    corporateId && siteId
      ? `${ServicesURL.rooms.replace(
          "{corporateId}",
          String(corporateId),
        )}?siteId=${siteId}&bookable=true`
      : null;

  return usePaginatedList<RoomListItem>(url, {
    page,
    pageSize,
    search,
    searchField: "name",
  });
};

export const formatSiteAddress = (s: SiteListItem): string =>
  [
    s.street,
    s.street_number,
    s.municipality,
    s.postal_code,
    s.country_description || s.country_code,
  ]
    .filter(Boolean)
    .join(", ");
